export class Item {
    id: string;
    name: string;
    minimum_quantity: string;
    cost: string;
    sale: string;
    barcode: string;
    status: string = '2';
    items_groups_id: string;
    picture: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/items/items.ts